import { Node, Edge } from 'reactflow';

export const initialNodes: Node[] = [
  {
    id: "start",
    type: "start",
    position: { x: 40, y: 180 },
    data: { type: "start", label: "Start", description: "Blueprint begins here", content: "" },
    deletable: false,
    draggable: true,
  },
  {
    id: "end",
    type: "end",
    position: { x: 800, y: 180 },
    data: { type: "end", label: "End", description: "Blueprint ends here", content: "" },
    deletable: false,
    draggable: true,
  },
];

export const initialEdges: Edge[] = [];